import { types, actions } from './requests'
export const GETCOSTLIST_TYPES = {
    ...types('GETCOSTLIST'),
}
export const GETCOSTLIST_ACTIONS = {
    ...actions('GETCOSTLIST'),
}
